import { useData, useDispatch } from "./DataContext.js";
import { style } from "./Style.js";

import Markdown from "react-markdown";
import RehypeRaw from "rehype-raw";

import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";

import ImpactList from "./ImpactList.js";

export default function TitleModal (props)
{
    const gData = useData();
    const gDispatch = useDispatch();

    let themeContent = {
	themeTitle: "",
	description: "",
	startCharId: null,
	startPlaceId: null,
    };
    
    if (gData.state.currentThemeId !== null) themeContent = gData.content.themes[gData.state.currentThemeId];

    function closeTitle ()
    {
	if (gData.content.params.autoFullscreen) document.body.requestFullscreen().catch((err) => {});
	gDispatch({ type: "closeModal", modal: "title" });
	if (themeContent.startCharId !== null) gDispatch({ type: "goToPlaceAndChar", charId: themeContent.startCharId, placeId: themeContent.startPlaceId });
	gDispatch({ type: "startRealTime" });
    }

    const bgImageSrc = gData.gameId + "/pictures/title.jpg";

    return (
	<Modal
	    backdropClassName="opacity-100"
	    dialogClassName="modal-xxl bg-transparent"
	contentClassName={"modal-content-xxl " + style.modal.content.className}
	    show={gData.state.showModals.title}
	onHide={closeTitle}
	centered
	scrollable={true}
	backdrop="static"
        keyboard={false}
	style={{ backgroundImage: "url(" + bgImageSrc + ")", backgroundRepeat: "no-repeat", backgroundSize: "cover" }}
	>
	    <Modal.Body className="bg-transparent py-5">
		<h1 className={"w-100 mb-4 text-center text-uppercase fs-1 fw-bold " + style.title.className} style={style.title.style}>{themeContent.title}</h1>
		{themeContent.description !== null && (
		    <div className={"m-5 " + style.title.text.className}>
			<Markdown rehypePlugins={[ RehypeRaw ]}>{themeContent.description}</Markdown>
		    </div>
		)}
		{themeContent.description === null && (
		    <div className="mt-5 w-50 m-auto">
			<div className="text-uppercase fs-5 fw-medium">État actuel de l'entreprise</div>
			<ImpactList type="state"/>
		    </div>
		)}
		<div className="text-center mt-4">
		    <Button variant={style.button.variant} size="lg" onClick={closeTitle} style={{ width: "300px" }}>C'est parti !</Button>
		</div>
	    </Modal.Body>
	</Modal>
    );
}

